module.exports = __webpack_public_path__ + "static/media/vag-rounded-bt.eba6ff47.ttf";